module.exports = __webpack_public_path__ + "static/media/dev-4.9554a3c5.png";